import React from 'react'


export default function VUSeal({ size = 200, tagline = false }) {
  return (
    <img
      src={tagline ? '/vu-logo-navy.png' : '/vu-logo-navy-notagline.png'}
      alt="Vacatia University Seal"
      width={size}
      height={size}
      style={{ display: 'block', width: size, height: 'auto' }}
    />
  )
}
